// extracted by mini-css-extract-plugin
export default {"heading":"Heading-module__heading___-W4tW","title":"Heading-module__title___BPzR1","headingCtaLink":"Heading-module__headingCtaLink___BPAQf","cta":"Heading-module__cta___7+FFG"};